export default __webpack_public_path__ + "static/media/mir.e1a3cf22.svg";